var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('themed-button',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.$emit('reload-action')}}},[_vm._v("\n        reload\n    ")]),_c('span',{staticClass:"px-1"},[_vm._v("\n        Last: "+_vm._s(_vm._f("humanReadableDate")(_vm.lastExecuted,'hour'))+"\n    ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }